import dayjs from "dayjs";
import { sortGrid } from "../sortGrid";

const adaptRegionReport = (regionReport: IRegionReport[]) => {
	const flatData: any = {};

	regionReport.forEach((regionReport: IRegionReport) => {
		// new row, create a new object
		if (flatData[`k_${regionReport.region_id}`] === undefined) {
			flatData[`k_${regionReport.region_id}`] = {};

			flatData[`k_${regionReport.region_id}`]["name"] =
				regionReport.region_name;

			flatData[`k_${regionReport.region_id}`]["regionId"] =
				regionReport.region_id;
		}

		const key = dayjs()
			.month(regionReport.month - 1)
			.format("MMM");

		flatData[`k_${regionReport.region_id}`][key] = {
			complete: regionReport.complete_count,
			compliant: regionReport.compliant_count,
			passedThreshold: regionReport.store_threshold_count,
			month: regionReport.month,
			graded: regionReport.graded_count,
			totalUserCount: regionReport.total_user_count
		};
	});

	// Flatten the data
	const data = Object.keys(flatData).map((key) => flatData[key]);

	sortGrid(data, "name");

	return data;
};

export default adaptRegionReport;
